import { AnswerType } from '../../shared/enums/answer.enum';
import { Answer } from './answer.model';

// @dynamic
export type KeywordQuestionAnswer = string;

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class KeywordAnswer extends Answer {
  public answer: KeywordQuestionAnswer | undefined;

  constructor(id: string, type: AnswerType, answer?: KeywordQuestionAnswer) {
    super();
    this.id = id;
    this.type = type;
    this.answer = answer;
  }

  public static fromDto(dto: any): KeywordAnswer {
    return new KeywordAnswer(dto.id, dto.type, dto.answer);
  }
}
